export const isSuccessfulStatusCode = (statusCode: number): boolean => `${statusCode}`.startsWith('20')
